export type ClientProfileTab =
    | "profile"
    | "team"
    | "channel-retail"
    | "channel-b2b"
    | "channel-online"
    | "purchase-behavior"
    | "orders"
    | "history";

type MinimalUser = {
    permissions?: string[];
    role: string;
} | null | undefined;

const CHANNEL_TABS: ClientProfileTab[] = ["channel-retail", "channel-b2b", "channel-online"];

export function parseProfileTab(value: string | null): ClientProfileTab {
    if (value === "team" || value === "purchase-behavior" || value === "orders" || value === "history") {
        return value;
    }

    if (CHANNEL_TABS.includes(value as ClientProfileTab)) {
        return value as ClientProfileTab;
    }

    return "profile";
}

export function canEditLoyaltyCard(user: MinimalUser) {
    return Boolean(
        user?.permissions?.some((permission) => ["users.manage", "roles.manage"].includes(permission))
        || (user && ["administrator", "sales_supervisor", "management"].includes(user.role))
        || user?.permissions?.includes("dashboard.management"),
    );
}

export function formatLocalDate(date: Date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
}

export function dateMonthsAgo(months: number) {
    const date = new Date();
    date.setMonth(date.getMonth() - months);

    return formatLocalDate(date);
}

